import { createContext } from "react";
import { Configuration } from "../../../Utils/Configuration";

export const ConfigurationContext = createContext<Configuration>(null);
